import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { Spinner } from "@heroui/react";
import CspResourceTable from "@/components/csp-resources/CspResourceTable";
import useAuth from "@/lib/auth/useAuth";
import useLayout from "@/lib/layout/useLayout";

export const Route = createFileRoute(
    "/dashboard/csp-portal/$organizationId/resources",
)({
    component: CspResources,
});

function CspResources() {
    const { organizationId } = Route.useParams();
    const navigate = useNavigate();
    const { user, isConsultant, isFetched } = useAuth();
    const { setLayoutState } = useLayout();
    const organization =
        user?.organization && typeof user.organization === "object"
            ? user.organization
            : undefined;
    const eligible =
        isConsultant && organization?.group_type === "service provider";
    const ownOrganizationId = eligible ? String(organization.id) : undefined;
    const canRead = Boolean(
        isFetched && ownOrganizationId && ownOrganizationId === organizationId,
    );

    useEffect(() => {
        setLayoutState("full_screen");
    }, [setLayoutState]);

    useEffect(() => {
        if (!isFetched) return;
        if (!ownOrganizationId) {
            navigate({ to: "/dashboard/home", replace: true });
        } else if (ownOrganizationId !== organizationId) {
            navigate({
                to: "/dashboard/csp-portal/$organizationId/resources",
                params: { organizationId: ownOrganizationId },
                replace: true,
            });
        }
    }, [isFetched, navigate, organizationId, ownOrganizationId]);

    if (!canRead || !organization)
        return (
            <div className="flex h-full items-center justify-center">
                <Spinner label="Loading resources" />
            </div>
        );

    return <CspResourceTable key={organization.id} scope={organization} />;
}
